import { render } from "./TabCycle.vue?vue&type=template&id=7cb06673"
import script from "./TabCycle.vue?vue&type=script&lang=js"
export * from "./TabCycle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__